import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  image: "",
  error: ""
}

const imageUploadSlice = createSlice({
  name: "imageUploadSlice",
  initialState: initialState,
  reducers: {
    uploadImage: () => {
    },
    removeImage: () => {
    },
    setLoading: (state) => {
      state.loading = true;
    },
    setImage: (state, action) => {
      state.image = action.payload
      state.loading = false
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    }
  },
});

export const {setLoading, setError, setImage, uploadImage, removeImage} = imageUploadSlice.actions;
export default imageUploadSlice.reducer;